// After a deploy, a tab still running the previous build calls Server Actions
// by IDs the new server no longer knows. Next answers 404 and the client throws
// `Server Action "<id>" was not found on the server`. Nothing in that tab can
// recover on its own — only a reload picks up the new build — so do that once,
// automatically, instead of leaving a list that silently fails to load.

const STALE_ACTION_RE = /Server Action .*was not found on the server/i;
const RELOAD_FLAG = 'pp_stale_deploy_reload';

export function isStaleDeploymentError(err: unknown): boolean {
  const message =
    err instanceof Error ? err.message : typeof err === 'string' ? err : '';
  return STALE_ACTION_RE.test(message);
}

/**
 * Reloads the page when `err` is the stale-deployment error. Guarded to one
 * reload per tab session so a genuinely broken server can't loop the page.
 */
export function reloadIfStaleDeployment(err: unknown): boolean {
  if (typeof window === 'undefined' || !isStaleDeploymentError(err)) {
    return false;
  }
  try {
    if (sessionStorage.getItem(RELOAD_FLAG)) return false;
    sessionStorage.setItem(RELOAD_FLAG, '1');
  } catch {
    // Without storage there is no way to count reloads, so don't risk a loop;
    // the user sees the failed request and reloads by hand as before.
    return false;
  }
  window.location.reload();
  return true;
}

/** Clears the one-reload guard once a build is confirmed working. */
export function markDeploymentHealthy() {
  try {
    sessionStorage.removeItem(RELOAD_FLAG);
  } catch {
    // ignore
  }
}
